<div class="is-fullwidth">
    <div class="columns is-multiline is-justified-center has-text-left is-mobile is-aligned-center">
        <div class="column is-1-tablet is-4-mobile">
            <picture>
                <img
                    [defaultImage]="defaultImage"
                    [lazyLoad]="images"
                    [useSrcset]="true"
                    alt="{{ data.name }}"
                    class="product-item-image"
                />
            </picture>
        </div>
        <div class="column is-11-tablet is-8-mobile">
            <div class="columns">
                <div class="column is-10">
                    <p class="text is-level-1 has-text-weight-semibold is-marginless">{{ data.name }}</p>
                    @if (type === TYPES.option_salable) {
                        <p
                            class="text is-level-2 min-h-2b is-marginless"
                            [innerHTML]="data.short_description | trustHtml"
                        ></p>
                    } @else {
                        <p class="text is-level-2 min-h-2b is-marginless">
                            {{ data?.color }}
                        </p>
                    }
                    <div class="is-flex is-spaced-between">
                        @if (type === TYPES.option_salable) {
                            <div class="rows">
                                <div class="row">
                                    <p class="wording-promo has-text-info has-text-weight-semibold is-marginless">
                                        {{ product.data.wording_promo }}
                                    </p>
                                </div>
                                <div class="row pt-0">
                                    @if (product.data.wording_promo) {
                                        <span>puis &nbsp;</span>
                                    }
                                    <div *ngTemplateOutlet="prices; context: { product: product, period: true }"></div>
                                </div>
                            </div>

                            <div></div>
                        } @else {
                            <div class="rows">
                                <div class="row">
                                    <div *ngTemplateOutlet="prices; context: { product: product, period: false }"></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="column has-text-right pr-0 is-2 is-flex is-aligned-end">
                    <div class="rows">
                        <div class="row">
                            @if (type === TYPES.accessory && data.max_qty > 1) {
                                <div class="field">
                                    <div class="control">
                                        <div class="select is-secondary">
                                            <select
                                                [attr.aria-label]="'Choisir une quantité pour: ' + data.name"
                                                (change)="updateItem()"
                                                [(ngModel)]="currentQty"
                                            >
                                                @for (val of productMaxQty; track val) {
                                                    <option
                                                        [ngValue]="val"
                                                        [disabled]="val - currentQty + totalProductsQty > maxItemsQty"
                                                    >
                                                        {{ val }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="row is-flex is-justified-end is-aligned-end">
                            @if (canBeRemoved) {
                                <button
                                    role="button"
                                    [attr.aria-label]="'Supprimer: ' + product.name"
                                    (click)="removeItem()"
                                    class="link button-clear"
                                >
                                    Supprimer
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #prices let-product="product" let-period="period">
    @if (product.prices.base > (product | priceWithoutCoupon)) {
        <trg-price [isDiscountPrice]="true" [price]="product.prices.base" class="is-margin" [size]="'is-level-6'" />
        <trg-price [hasPeriod]="period" [price]="product | priceWithoutCoupon" [size]="'is-level-6'" />
    } @else {
        <trg-price
            [hasPeriod]="period"
            [price]="product | priceWithoutCoupon"
            class="is-margin"
            [size]="'is-level-6'"
        />
    }
</ng-template>
